

















import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import BaseButton from "@/components/BaseButton";
import BaseCard from "@/components/BaseCard";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "CardInfo",
  components: { BaseCard, BaseButton, BaseIcon },
  props: {
    showClose: { type: Boolean, default: false },
    title: { type: String },
    buttonText: { type: String },
    to: { type: Object as () => Location },
  },
  data() {
    return {
      show: true,
    };
  },
});
